// AgentCore Runtime keeps conversation state per session; the ID must be at least 33 characters (a UUID is 36).
export const ARIA_CHAT_SESSION_HEADER = 'X-Amzn-Bedrock-AgentCore-Runtime-Session-Id';
export const ARIA_CHAT_SESSION_KEY = 'ariaChatSessionId';
export const MAX_QUERY_LENGTH = 1000;
// i18n namespace: messages/ariaChat.puff.json, public/locales/<locale>/ariaChat.json5
export const ARIA_CHAT_NAMESPACE = 'ariaChat';
// Stages (the `stage` value in settings.json) where the widget is shown. Not yet enabled in Gamma or Prod.
export const ARIA_CHAT_ENABLED_STAGES = ['Development', 'Alpha', 'Beta'];
